import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, IconButton, CssBaseline } from '@mui/material';
import { getMenuItems } from '../../services/api';
import { MenuItem } from '../../types/MenuItem';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import Navbar from './Navbar';
import SubscriptionForm from '../subscription/SubscriptionForm';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import TikTokIcon from '@mui/icons-material/MusicVideo'; // Using MusicVideo as a substitute for TikTok

interface LayoutProps {
  children: React.ReactNode;
  content: object | any;
}

const Layout: React.FC<LayoutProps> = ({ children, content  }: any) => {
  const [menus, setMenus] = useState<MenuItem[]>();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // setIsLoading(true)
        const { data } = await getMenuItems();
        setMenus(data)
      } catch (error) {
        setIsError(true);
        enqueueSnackbar((error as any).message, { variant: 'error' });
      } finally {
        // setIsLoading(false);
      }
    }
    fetchCategories()
  },[]);
  
  return ( isError ? 
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="60vh"
      p={4}
    >
      <img
        src="/assets/images/server_error.png"
        alt="404 Not Found"
        style={{ maxWidth: '100%', height: 'auto', marginBottom: '20px' }}
      />
    </Box> :
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <Navbar content={content} />
      <Container component="main" sx={{ mt: 4, mb: 4, flex: 1 }}>
        {children}
      </Container>
      <SubscriptionForm />
      <Box
        component="footer"
        sx={{
          py: 4,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? '#8B5A2B' // Rich brown
              : '#2C1810', // Dark brown
          color: '#F8F4E9', // Light cream
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={3} justifyContent="center">
            {/* @ts-ignore */}
            <Grid item xs={12}>
              <Typography
                variant="h4"
                component="div"
                align="center"
                sx={{
                  mb: 3,
                  fontFamily: "'Playfair Display', serif",
                  color: 'white',
                }}
              >
                {content?.footerText}
              </Typography>
            </Grid>
            {/* @ts-ignore */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                {menus?.map((menu, index) => {
                  const platformIcons: { [key: string]: React.ReactNode } = {
                    Facebook: <FacebookIcon />,
                    Instagram: <InstagramIcon />,
                    Pinterest: <PinterestIcon />,
                    YouTube: <YouTubeIcon />,
                    TikTok: <TikTokIcon />,
                    Twitter: <TwitterIcon />,
                    // Add more platforms and their icons if needed
                  };

                  const icon = platformIcons[menu.platform] || <FacebookIcon />; // default fallback
                  
                  return (
                    <IconButton
                      key={index}
                      href={menu.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: 'white' }}
                    >
                      {icon}
                    </IconButton>
                  )
                })}
              </Box>
            </Grid>
            {/* @ts-ignore */}
            <Grid item xs={12}>
              <Typography
                variant="body2"
                align="center"
                color="white"
                sx={{ mt: 2 }}
              >
                {content?.footerCopyright}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <SnackbarProvider />
    </Box>
  );
};

export default Layout; 